import React from 'react';
import Tooltip from './Tooltip';
import styles from './Tooltip.module.scss';
import UIcon from '@/assets/uicons/UIcon';

interface UserData {
  name: string;
  avatarUrl?: string;
  role?: string;
  email?: string;
  phone?: string | null;
  team?: string;
  localTime?: string;
  collaboratingProjects?: number;
}

interface UserTooltipProps {
  children: React.ReactNode;
  user: UserData;
  placement?: 'top' | 'bottom' | 'left' | 'right';
  showActions?: boolean;
  onAssignTask?: () => void;
  onViewProfile?: () => void;
}

const UserTooltip: React.FC<UserTooltipProps> = ({
  children,
  user,
  placement = 'top',
  showActions = true,
  onAssignTask,
  onViewProfile
}) => {
  const tooltipContent = (
    <div className={styles.userTooltip}>
      <div className={styles.userAvatar}>
        {user.avatarUrl ? (
          <img src={user.avatarUrl} alt={user.name} />
        ) : (
          user.name
            .split(' ')
            .slice(0, 2)
            .map(n => n[0])
            .join('')
            .toUpperCase()
        )}
      </div>
      
      <div className={styles.userInfo}>
        <div className={styles.userName}>{user.name}</div>
        
        {user.role && (
          <div className={styles.userRole}>
            <UIcon name="badge" size={14} />
            <span>{user.role}</span>
          </div>
        )}
        
        {user.email && (
          <div className={styles.userEmail}>
            <UIcon name="mail" size={14} /> 
            <span>{user.email}</span>
          </div>
        )}
        
        {user.phone && (
          <div className={styles.userPhone}>
            <UIcon name="phone" size={14} /> 
            <span>{user.phone}</span>
          </div>
        )}

        {user.team && (
          <div className={styles.userRole}>
            <UIcon name="users" size={14} />
            <span>{user.team}</span>
          </div>
        )}
        
        {user.localTime && (
          <div className={styles.userTime}>{user.localTime}</div>
        )}
        
        {typeof user.collaboratingProjects === 'number' && (
          <div className={styles.userStats}>
            Colaborando en {user.collaboratingProjects} proyecto{user.collaboratingProjects !== 1 ? 's' : ''}
          </div>
        )}
        
        {showActions && (
          <div className={styles.userActions}>
            {onAssignTask && (
              <button 
                className={`${styles.userAction} ${styles['userAction--primary']}`}
                onClick={onAssignTask}
              >
                Asignar tarea
              </button>
            )}
            {onViewProfile && (
              <button 
                className={`${styles.userAction} ${styles['userAction--secondary']}`}
                onClick={onViewProfile}
              >
                Ver perfil
              </button>
            )}
          </div>
        )}
      </div>
    </div>
  );

  return (
    <Tooltip content={tooltipContent} placement={placement} offset={12} hideDelay={200}>
      {children}
    </Tooltip>
  );
};

export default UserTooltip; 